import { useEffect, useState } from "react";
import api from "../../api/api";
import Swal from "sweetalert2";
import "./SelecionarCliente.module.scss";

const SelecionarCliente = () => {
  const [formCliente, setFormCliente] = useState({
    nome: "",
    cnpj_cpf: "",
    email: "",
    telefone: "",
    endereco: "",
  });

  const [formUsuario, setFormUsuario] = useState({
    nome: "",
    login: "",
    senha: "",
    cargo: "",
    nivel_acesso: "admin",
    cliente_id: "",
  });

  const [clientes, setClientes] = useState([]);

  useEffect(() => {
    const fetchClientes = async () => {
      try {
        const res = await api.get("/clientes/all");
        setClientes(res.data);
      } catch (err) {
        console.error(err);
        Swal.fire("Erro", "Não foi possível buscar clientes.", "error");
      }
    };
    fetchClientes();
  }, []);

  const handleChangeCliente = (e) => {
    setFormCliente({ ...formCliente, [e.target.name]: e.target.value });
  };

  const handleSubmitCliente = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post("/clientes", formCliente);
      Swal.fire("Sucesso!", `Cliente ${res.data.nome} criado.`, "success");
      setFormCliente({ nome: "", cnpj_cpf: "", email: "", telefone: "", endereco: "" });
      setClientes((prev) => [...prev, res.data]);
    } catch (err) {
      console.error(err);
      Swal.fire("Erro!", err.response?.data?.error || "Erro ao criar cliente.", "error");
    }
  };

  const handleChangeUsuario = (e) => {
    setFormUsuario({ ...formUsuario, [e.target.name]: e.target.value });
  };

  const handleSubmitUsuario = async (e) => {
    e.preventDefault();
    try {
      await api.post("/usuarios/register", formUsuario);
      Swal.fire("Sucesso!", `Usuário ${formUsuario.nome} criado.`, "success");
      setFormUsuario({ nome: "", login: "", senha: "", cargo: "", nivel_acesso: "admin", cliente_id: "" });
    } catch (err) {
      console.error(err);
      Swal.fire("Erro!", err.response?.data?.error || "Erro ao criar usuário.", "error");
    }
  };

  return (
    <div className="selecionar-cliente">
      <div className="card">
        <h2>Criar Cliente</h2>
        <form onSubmit={handleSubmitCliente}>
          <label>Nome</label>
          <input name="nome" value={formCliente.nome} onChange={handleChangeCliente} required />

          <label>CNPJ/CPF</label>
          <input name="cnpj_cpf" value={formCliente.cnpj_cpf} onChange={handleChangeCliente} required />

          <label>Email</label>
          <input name="email" value={formCliente.email} onChange={handleChangeCliente} required />

          <label>Telefone</label>
          <input name="telefone" value={formCliente.telefone} onChange={handleChangeCliente} required />

          <label>Endereço</label>
          <input name="endereco" value={formCliente.endereco} onChange={handleChangeCliente} required />

          <button type="submit">Criar Cliente</button>
        </form>
      </div>

      <div className="card">
        <h2>Criar Usuário</h2>
        <form onSubmit={handleSubmitUsuario}>
          <label>Nome</label>
          <input name="nome" value={formUsuario.nome} onChange={handleChangeUsuario} required />

          <label>Login</label>
          <input name="login" value={formUsuario.login} onChange={handleChangeUsuario} required />

          <label>Senha</label>
          <input type="password" name="senha" value={formUsuario.senha} onChange={handleChangeUsuario} required />

          <label>Cargo</label>
          <input name="cargo" value={formUsuario.cargo} onChange={handleChangeUsuario} required />

          <label>Nível de Acesso</label>
          <select name="nivel_acesso" value={formUsuario.nivel_acesso} onChange={handleChangeUsuario}>
            <option value="admin">Admin</option>
            <option value="vendedor">Vendedor</option>
            <option value="estoque">Estoque</option>
            <option value="superadmin">Superadmin</option>
          </select>

          <label>Cliente</label>
          <select name="cliente_id" value={formUsuario.cliente_id} onChange={handleChangeUsuario} required>
            <option value="">Selecionar Cliente</option>
            {clientes.map((c) => (
              <option key={c.id} value={c.id}>{c.nome}</option>
            ))}
          </select>

          <button type="submit">Criar Usuário</button>
        </form>
      </div>
    </div>
  );
};

export default SelecionarCliente;
